import Vue from 'vue'
import {
    Button, Cell, CellGroup, Image, Row, Col, Popup, Checkbox, CheckboxGroup, DatetimePicker,
    Field, Picker, Lazyload, Search, Loading, Toast, Tabbar, TabbarItem, NavBar, Swipe, SwipeItem,
    Icon, Tag, DropdownMenu, DropdownItem, Dialog, List, PullRefresh, ImagePreview, CouponCell, CouponList,
    Overlay, Divider, Uploader, Step, Steps, IndexBar, IndexAnchor, TreeSelect, NumberKeyboard, SubmitBar,
    Collapse, CollapseItem, Skeleton, RadioGroup, Radio, Tab, Tabs, Progress, Circle
} from 'vant'

Vue.use(Button).use(Cell).use(CellGroup).use(Image).use(Row).use(Col).use(Popup).use(Checkbox).use(CheckboxGroup).use(DatetimePicker)
    .use(Field).use(Picker).use(Lazyload, {
        preLoad: 1.3,
        error: `${process.env.BASE_URL}lazyload.png`,
        loading: `${process.env.BASE_URL}jkt.png`,
        attempt: 1}).use(Search).use(Loading).use(Tabbar).use(TabbarItem).use(NavBar).use(Swipe).use(SwipeItem)
    .use(Icon).use(Tag).use(DropdownMenu).use(DropdownItem).use(Dialog).use(List).use(PullRefresh).use(ImagePreview).use(CouponCell).use(CouponList)
    .use(Overlay).use(Divider).use(Uploader).use(Step).use(Steps).use(IndexBar).use(IndexAnchor).use(TreeSelect).use(NumberKeyboard).use(SubmitBar)
    .use(Collapse).use(CollapseItem).use(Skeleton).use(RadioGroup).use(Radio).use(Tab).use(Tabs).use(Progress).use(Circle)

Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
